export default "__VITE_ASSET__c1a2b82b__"